import { all } from 'redux-saga/effects'

import { dealsSaga } from './deals/operations'
import { investorChecksSaga } from './investorChecks/operations'
import { organizationsSaga } from './organizations/operations'
import { peopleSaga } from './people/operations'

export function* dataSaga() {
  yield all([organizationsSaga(), dealsSaga(), investorChecksSaga(), peopleSaga()])
}
